import { computed } from 'vue';
import {
    processStd,
    processStepTs,
    processStepNameTs,
    requirementFieldTs,
    requirementFormTs,
} from '@/views/departmentalRequirements/servestd';
import store from "@/store";
import { timeStampToTime } from '@/utils';

const options = computed(() => store.state.noticeStaffData);

export const progressList: Array<processStd> = [
    {
        step: "demand",
        name: "客户端",
    },
    {
        step: "requirementReview",
        name: "客户端负责人"
    },
    {
        step: "executiveChampion",
        name: "服务端负责人"
    },
    {
        step: "executor",
        name: "服务端执行人"
    },
    {
        step: "deliveryTasks",
        name: "交付"
    },
    {
        step: "deliveryConfirmation",
        name: "交付确认"
    },
    {
        step: "close",
        name: "close"
    }
];


export const STATUS = {
    // 0: '客户端',
    // 1: '客户端负责人',
    // 2: '服务端负责人',
    // 3: '服务端执行人',
    // 4: '交付确认',
    // 5: '交付',
    // 6: '退回',
    // 7: 'close',
    0: "审核需求",
    1: "接收需求",
    2: "执行需求",
    3: "需求交付",
    4: "审核交付",
    5: "完成",
};
// 需求流程
export const requirementProgress = [
    {
        name: "审核需求",
        value: "requirementReview",
    },
    {
        name: "接收需求",
        value: "executiveChampion",
    },
    {
        name: "执行需求",
        value: "executor",
    },
    {
        name: "需求交付",
        value: "deliveryTasks",
    },
    {
        name: "审核交付",
        value: "deliveryConfirmation",
    },
    {
        name: "完成",
        value: "close",
    },
];

// 设置默认流程
const setDefaultTimeLine = (content, process) => {
    return {
        // 内容
        content,
        // 时间
        time: "",
        // 状态
        color: "gray",
        // 流程
        process,
    };
};

// 新增操作的时间线流程
export const insertStep = (nickName) => {
    const timeLine = setDefaultTimeLine(`${nickName}新增跨部门需求`, 'insertRequirement');

    timeLine.time = timeStampToTime('', 'upload');
    timeLine.color = 'green';

    return timeLine;
};

// 审核操作时间线
export const examineStep = (nickName) => {
    const timeLine = setDefaultTimeLine(`审核需求 ${nickName}`, 'requirementReview');

    timeLine.time = timeStampToTime('', 'upload');
    timeLine.color = 'green';

    return timeLine;
};

// 接收需求操作时间线
export const receiveStep = (nickName, isReceive) => {
    const isReceiveText = isReceive ? '接收' : '拒绝';
    const isReceiveColor = isReceive ? 'green' : 'red';
    const timeLine = setDefaultTimeLine(`${isReceiveText}需求 ${nickName}`, 'executiveChampion');
    timeLine.time = timeStampToTime('', 'upload');
    timeLine.color = isReceiveColor;
    return timeLine;
};

// 需求执行人操作时间线
export const executeStep = (nickName) => {
    const timeLine = setDefaultTimeLine(`执行需求 ${nickName}`, 'executor');
    timeLine.time = timeStampToTime('', 'upload');
    timeLine.color = 'green';
    return timeLine;
};

// 执行人交付操作时间线
export const deliveryTasksStep = (nickName) => {
    const timeLine = setDefaultTimeLine(`需求交付 ${nickName}`, 'deliveryTasks');
    timeLine.time = timeStampToTime('', 'upload');
    timeLine.color = 'green';
    return timeLine;
};

// 审核交付操作时间线
export const deliveryConfirmationStep = (nickName, confirmation) => {
    if (confirmation === '进行中') {
        const timeLine = setDefaultTimeLine(`确认需求进行中 ${nickName}`, 'deliveryConfirmation');
        timeLine.time = timeStampToTime('', 'upload');
        timeLine.color = '#2db7f5';
        return timeLine
    }

    const isDelivery = confirmation === '确认';

    const isDeliveryText = isDelivery ? '确认' : '退回';
    const isDeliveryColor = isDelivery ? 'green' : 'red';
    const timeLine = setDefaultTimeLine(`${isDeliveryText}需求交付 ${nickName}`, 'deliveryConfirmation');
    timeLine.time = timeStampToTime('', 'upload');
    timeLine.color = isDeliveryColor;
    return timeLine;
};

// 关闭操作时间线
export const closeStep = () => {
    const timeLine = setDefaultTimeLine(`跨部门需求完成`, 'close');
    timeLine.time = timeStampToTime('', 'upload');
    timeLine.color = 'green';
    return timeLine;
};

// 获取默认流程
const getDefaultTimeLine = (list) => {
    const timeLineList = [];

    list.forEach((item) => {
        const timelineItem = setDefaultTimeLine(item.name, item.value);
        timeLineList.push(timelineItem);
    });

    return timeLineList;
};

// 补齐流程
export const completionTimeLine = (stringProgress, type) => {
    const list = [];
    let lastIndex = 0;
    let sliceIndex = 0;
    // 有数据

    if (stringProgress && String(stringProgress).indexOf('[') !== -1) {
        const processList = JSON.parse(stringProgress);
        list.push(...processList);
    }

    // 最新的数据
    if (list.length !== 0) {
        sliceIndex = list.length;
        lastIndex = list.length - 1;
    }


    // 需要补齐的流程
    const durList = requirementProgress.slice(sliceIndex);

    const durTimeLine = getDefaultTimeLine(durList);

    // 表单新增数据
    if (type === 'insert') {
        return durTimeLine[0];
    }

    list.push(...durTimeLine);


    return list;
};

export const getStatusIndexByName = (progress) => {
    let lastIndex = null;

    if (progress === null) {
        // progress = STATUS[0];
        lastIndex = 0;
    } else {
        const progressList = JSON.parse(progress).filter((f) => f.time);

        lastIndex = progressList.length;

        const current = progressList[lastIndex - 1];

        if (current.color !== 'green') {
            lastIndex = progressList.length - 1;
        }


    }

    if (lastIndex === requirementProgress.length) {
        lastIndex = requirementProgress.length - 1;
    }
    // let statusIndex = null;
    // if (lastIndex !== null) {
    //     progress
    // }
    // Object.keys(STATUS).forEach((key) => {
    //     if (STATUS[key] === progress) {
    //         statusIndex = Number(key);
    //     }
    // });
    return lastIndex;
};

export const getProgressIndex = (index, progressName) => {
    const fname = progressList[index].name;
    return fname !== progressName;
};

export const getProgressIndexName = (index) => {
    return progressList[index].name;
};

/**
 * 获取下一个阶段的进度
 * 不传参数返回第一个阶段{ step: "demand",name: "客户端" }
 * 传入progress 对应的name返回下一个阶段
*/
export const getNextProgress = (progress?: string): processStd | Error => {
    if (!progress) return progressList[0];

    let findIndex = progressList.findIndex((f) => f.name === progress);

    if (findIndex === -1) return new Error('请检查progress参数以及progressList列表');

    if (findIndex + 1 >= progressList.length) {
        findIndex = progressList.length - 2;
    }
    findIndex += 1;
    return progressList[findIndex]
};

export const getCurrentProgress = (progress?: string): processStd | Error => {
    if (!progress) return progressList[0];

    let findIndex = progressList.findIndex((f) => f.name === progress);

    if (findIndex === -1) return new Error('请检查progress参数以及progressList列表');

    if (findIndex + 1 >= progressList.length) {
        findIndex = progressList.length - 1;
    }
    return progressList[findIndex]
};

/**
 * 表单字段
*/
const formField: processStepTs = {
    // 提出需求
    demand: [
        // 需求名称
        'requirementName',
        // 需求内容
        'requirementContent',
        // 需求文件
        'requirementFile',
        // 需求文件
        'completeRequirementDept',
        // 期望交付日期
        'expectedDeliveryDate',
    ],
    // 提出部门负责人审核需求
    requirementReview: [
        // 完成需求部门
        'completeRequirementDept',
    ],
    // 接收需求部门负责人审核
    executiveChampion: [
        // 是否接收
        'isReceive',
        // 执行人
        'executor',
    ],
    // 执行人处理需求
    executor: [
        // 可重新选择执行人
        'executor',
        // 是否交付
        'isDelivery',
        // 交付文件
        'deliveryFile',
    ],
    deliveryTasks: [
        'requirementDeliveryConfirmation',
    ],
    // 交付
    deliveryConfirmation: [
        'requirementDeliveryConfirmation',
    ],
    // 关闭
    close: [],
};

// 获取需要渲染的表单
export const getRenderForm = (processStep: processStepNameTs) => {
    const getField = (name: processStepNameTs, disabled: boolean): Array<requirementFieldTs> => {
        const list: Array<requirementFieldTs> = [];
        const fieldList = formField[name];
        fieldList.forEach((fileName) => {
            list.push({
                fileName,
                disabled,
            })
        })

        return list
    };

    const getMultipleField = (list: Array<{ name: processStepNameTs, disabled: boolean }>): Array<requirementFieldTs> => {
        const fieldList = [];

        list.forEach((item) => {
            fieldList.push(...getField(item.name, item.disabled));
        });

        return fieldList;
    };

    const step = {
        demand: [
            ...getMultipleField([
                { name: 'demand', disabled: false }
            ])
        ],
        requirementReview: [
            ...getMultipleField
                ([
                    { name: 'demand', disabled: false },
                    { name: 'requirementReview', disabled: false }
                ])],
        executiveChampion: [
            ...getMultipleField
                ([
                    { name: 'demand', disabled: true },
                    { name: 'requirementReview', disabled: true },
                    { name: 'executiveChampion', disabled: false },
                ])],
        executor: [
            ...getMultipleField
                ([
                    { name: 'demand', disabled: true },
                    { name: 'requirementReview', disabled: true },
                    { name: 'executiveChampion', disabled: true },
                    { name: 'executor', disabled: false },
                ])],
        deliveryTasks: [
            ...getMultipleField
                ([
                    { name: 'demand', disabled: true },
                    { name: 'requirementReview', disabled: true },
                    { name: 'executiveChampion', disabled: true },
                    { name: 'executor', disabled: false },
                ])],
        deliveryConfirmation: [
            ...getMultipleField
                ([
                    { name: 'demand', disabled: true },
                    { name: 'requirementReview', disabled: true },
                    { name: 'executiveChampion', disabled: true },
                    { name: 'executor', disabled: true },
                    { name: 'deliveryTasks', disabled: true },
                    { name: 'deliveryConfirmation', disabled: false }
                ])],

    }
    return step[processStep]
}

// 获取需求部门负责人

export const findDepartMentLeader = (firstLevelDepartment: string) => {

    let leader = null;
    let structure = null;
    const list = options.value;
    const structureCondition = (item) => {
        if (item.structureName === firstLevelDepartment) {
            structure = item;
        }
    };

    const leaderCondition = (item) => {
        if (structure && structure.id === item.structureId && item.isDL) {
            leader = item;
        }
    };

    const ite = (list, fn) => {
        list.forEach((item) => {
            fn(item);
            if (item.children && item.children.length > 0) {
                ite(item.children, fn);
            }
        });
    };

    ite(list, structureCondition);
    ite(list, leaderCondition);

    if (leader !== null) {
        leader.id = String(leader.id).replace(/P/, '');
    }
    return leader;
};

/**
 * 处理默认值
*/
export const setDefaultValue = (processStep: processStepNameTs) => {
    const setDemand = (formState: requirementFormTs, user) => {
        formState.demander.value = user.nickName;
        formState.demanderDept.value = user.firstLevelDepartment;
        formState.demanderId.value = user.id;
        const leader = findDepartMentLeader(formState.demanderDept.value);
        formState.progress.value = getNextProgress(null).name;
        formState.proposedTime.value = new Date();
        if (leader) {
            formState.demanderDeptHead.value = leader.nickName;
        }
    };

    const strategy = {
        demand: setDemand,
        requirementReview: null,
        executiveChampion: null,
        executor: null,
        deliveryTasks: null,
        deliveryConfirmation: null,
        close: null,
    };

    return strategy[processStep];
};

/**
 * 策略进度模式
 * 
*/
export const strategyProgress = {
    // demand: 
};



